import { render } from "./MandarIncidencias.vue?vue&type=template&id=029b31b2&scoped=true"
import script from "./MandarIncidencias.vue?vue&type=script&lang=js"
export * from "./MandarIncidencias.vue?vue&type=script&lang=js"

import "./MandarIncidencias.vue?vue&type=style&index=0&id=029b31b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029b31b2"]])

export default __exports__